export default __webpack_public_path__ + "static/media/right_bg_arrow_curved_down.649261eb.png";